export function excludeNumeric(string: string): string {
  return string.replace(/^\d$/g, '').trim();
}
